import { secureStorage } from './secureStorage'; // 🔒 NOUVEAU - Stockage sécurisé

export const isAuthenticated = () => {
  try {
    // Essayer d'abord le stockage sécurisé
    const secureAuthData = secureStorage.getItem('authData');
    if (secureAuthData) return true;
    
    // Fallback: vérifier l'ancien stockage non sécurisé
    const plainAuthData = localStorage.getItem('authData');
    if (plainAuthData) {
      // Migrer automatiquement vers le stockage sécurisé
      try {
        const parsedData = JSON.parse(plainAuthData);
        secureStorage.setItem('authData', parsedData);
        localStorage.removeItem('authData'); // Nettoyer l'ancien
        return true;
      } catch (error) {
        console.error('❌ Erreur migration auth:', error);
        localStorage.removeItem('authData'); // Nettoyer les données corrompues
        return false;
      }
    }
    
    return false;
  } catch (error) {
    console.error('❌ Erreur vérification auth:', error);
    return false;
  }
};

export const getAuthData = () => {
  try {
    // Essayer d'abord le stockage sécurisé
    const secureAuthData = secureStorage.getItem('authData');
    if (secureAuthData) return secureAuthData;
    
    // Fallback: vérifier l'ancien stockage non sécurisé et migrer
    const plainAuthData = localStorage.getItem('authData');
    if (plainAuthData) {
      try {
        const parsedData = JSON.parse(plainAuthData);
        // Migrer vers stockage sécurisé
        secureStorage.setItem('authData', parsedData);
        localStorage.removeItem('authData'); // Nettoyer l'ancien
        return parsedData;
      } catch (error) {
        console.error('❌ Erreur migration getAuthData:', error);
        localStorage.removeItem('authData'); // Nettoyer les données corrompues
        return null;
      }
    }
    
    return null;
  } catch (error) {
    console.error('❌ Erreur récupération auth:', error);
    return null;
  }
};

export const logout = () => {
  try {
    // Nettoyer le stockage sécurisé
    secureStorage.removeItem('authData');
    
    // Nettoyer aussi l'ancien stockage au cas où
    localStorage.removeItem('authData');
    
    // Redirection
    window.location.href = '/';
  } catch (error) {
    console.error('❌ Erreur logout:', error);
    // Forcer la redirection même en cas d'erreur
    window.location.href = '/';
  }
};